import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { TribuneAnalyticsService } from './../../../data/repository/analytics-repository/tribune-analytics.service';
import { LoadingShared } from './../../general/shared/loading-shared';
import { TextHelper } from './../../../utils/text-helper';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { Component, OnInit, Input } from '@angular/core';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';

@Component({
  selector: 'app-edit-name',
  templateUrl: './edit-name.component.html',
  styleUrls: ['./edit-name.component.scss'],
})
export class EditNameComponent implements OnInit {
  @Input() name: string;
  @Input() username: string;

  isName = true;
  message = '';
  hasError = false;

  isIOS = false;

  constructor(
    private userApiService: UserApiService,
    private blogService: BlogService,
    private textHelper: TextHelper,
    private loadingShared: LoadingShared,
    private tribuneAnalytics: TribuneAnalyticsService,
    private snackBarService: SnackBarService
  ) {
    this.isIOS = this.isIos();
  }

  ngOnInit() {
    if (this.name) {
      this.isName = true;
    } else if (this.username) {
      this.isName = false;
    }
    setTimeout(() => {
      if (!this.isIOS) {
        document.getElementById('input').focus();
      }
    }, 100);
  }

  save(): Promise<GenericResponse> {
    // console.log('saved', this.name);
    if (this.name) {
      return this.userApiService
        .editUser(this.name, null, null, null, null)
        .then((res) => {
          if (res.isSuccess()) {
            return this.blogService.editBlogUser(
              this.name,
              null,
              null,
              null,
              null
            );
          }
          return res;
        });
    } else if (this.username) {
      const checkAnswer = this.textHelper.checkUsername(this.username);
      if (checkAnswer === 'correct') {
        this.loadingShared.showLoading();
        return this.blogService.validateUsername(this.username).then((res) => {
          if (res.isSuccess()) {
            return this.blogService
              .editBlogUser(null, this.username, null, null, null)
              .then((result) => {
                if (result.isSuccess()) {
                  this.tribuneAnalytics.analyticTribuneUsernameSet();
                  this.snackBarService.showSnackBar(
                    'نام کاربری با موفقیت تغییر یافت.'
                  );
                }
                this.loadingShared.hideLoading();
                return result;
              });
          } else {
            if (res.getData().getMessage()) {
              this.message = res.getData().getMessage();
              this.hasError = true;
            } else {
              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
            this.loadingShared.hideLoading();
            return Promise.resolve(new GenericResponse(false));
          }
        });
      } else {
        this.message = checkAnswer;
        this.hasError = true;
        return Promise.resolve(new GenericResponse(false));
      }
    }
  }

  isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };
}
